import React from 'react';
import { Section } from './ui/Section';
export function Testimonials({
  limit = 3,
  className = ''
}: {
  limit?: number;
  className?: string;
}) {
  const allTestimonials = [{
    initials: 'AG',
    quote: 'En una semana entendí más de mi piel que en 10 años comprando cremas',
    author: 'Ana G. | Madrid | Piel mixta con rojeces'
  }, {
    initials: 'LP',
    quote: 'Tiré la mitad de mi baño y mi piel mejoró al instante',
    author: 'Laura P. | Barcelona | Acné adulto'
  }, {
    initials: 'SM',
    quote: 'Por fin entiendo por qué mi piel estaba peor cuanto más productos usaba',
    author: 'Sofía M. | Valencia | Piel sensible reactiva'
  }, {
    initials: 'CR',
    quote: 'Empecé con el pack base y a los 4 días compré el sistema completo. El Protocolo Reset me cambió la piel en literalmente una semana. Mis amigas me preguntan qué me he hecho.',
    author: 'Carmen R. | Barcelona | Acné adulto'
  }, {
    initials: 'IM',
    quote: 'Pensaba que mi piel era difícil. Resulta que simplemente estaba sobre-estimulada. Nunca nadie me lo había explicado así.',
    author: 'Inés M. | Valencia | Piel sensible reactiva'
  }, {
    initials: 'VT',
    quote: 'El Tomo 5 es exactamente lo que necesitaba. Por fin tengo un sistema que se adapta a mi piel con los años.',
    author: 'Valeria T. | Málaga | Piel madura 40+'
  }];
  // For limit=3, use the first 3 (opening). For limit=6, use all 6 (full section)
  const displayTestimonials = limit === 3 ? allTestimonials.slice(0, 3) : allTestimonials;
  return <Section className={className} variant={limit === 6 ? 'alt' : 'default'} data-id="element-213">
      {limit === 6 && <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-brand-title mb-12" data-id="element-214">
          ⭐ LO QUE DICEN LAS MUJERES QUE YA AUDITARON SU PIEL
        </h2>}
      <div className={`grid gap-6 ${limit === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-3'}`} data-id="element-215">
        {displayTestimonials.map((t, i) => <div key={i} className="bg-white border border-neutral-100 rounded-2xl p-6 flex flex-col shadow-sm hover:shadow-md transition-shadow" data-id="element-216">
            <div className="flex items-center gap-3 mb-4" data-id="element-217">
              <div className="w-10 h-10 rounded-full bg-brand-bgAlt flex items-center justify-center font-heading font-bold text-brand-title" data-id="element-218">
                {t.initials}
              </div>
              <div className="flex text-brand-gold text-sm" data-id="element-219">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="font-body text-brand-text italic mb-6 flex-grow" data-id="element-220">
              "{t.quote}"
            </p>
            <p className="font-heading text-xs text-brand-subtitle font-semibold" data-id="element-221">
              — {t.author}
            </p>
          </div>)}
      </div>
    </Section>;
}